import { Paragraph } from 'component-library';
import { joinNameAndDescription } from '@sr/utils';
import { type SelectedHierarchyInfo as SelHierarchy } from '../../types';

type SelectedHierarchyProps = {
  hierarchy: SelHierarchy | undefined;
};

const SelectedHierarchy: React.FC<SelectedHierarchyProps> = ({
  hierarchy,
}: SelectedHierarchyProps) =>
  hierarchy ? (
    <div>
      <Paragraph variant="large">
        {joinNameAndDescription(hierarchy.name, hierarchy.description)}
      </Paragraph>
      <Paragraph variant="large">{hierarchy.childCount}</Paragraph>
    </div>
  ) : null;

export default SelectedHierarchy;
